import { AppRoutes } from "@/routes/config";
import { TTabbedSessionState, useListSessionStorage } from "@/hooks/useListSessionStorage";

const MATCH_LIST_SESSION_KEY = "match_list_state";

export type TMatchListSessionState = TTabbedSessionState;

export const useMatchListSessionStorage = () => {
  return useListSessionStorage<TMatchListSessionState>({
    sessionKey: MATCH_LIST_SESSION_KEY,
    defaultBackUrl: AppRoutes.duringContractList,
    getBackUrlFromState: (state) => {
      const { activeTabUrl, searchParams } = state;
      if (searchParams) {
        return `${activeTabUrl}?${searchParams}`;
      }
      return activeTabUrl;
    },
  });
};
